module.exports = __webpack_public_path__ + "img/logo-youtube.7b6852d0.svg";